export const airWeightBracket = {
  lt45: "weightPriceLt45",
  gt45: "weightPriceGt45",
  gt100: "weightPriceGt100",
  gt300: "weightPriceGt300",
  gt500: "weightPriceGt500",
  gt1000: "weightPriceGt1000",
};
